import React from 'react';
import { ImageData } from '../utils/mockData';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';
interface BayesianDistributionChartProps {
  data: ImageData[];
}
interface DataPoint {
  spr: number;
  [key: string]: number;
}
export const BayesianDistributionChart: React.FC<BayesianDistributionChartProps> = ({
  data
}) => {
  // Find the minimum SPR value to determine x-axis starting point
  const minSPR = Math.min(...data.map(item => item.stoppingPower));
  const xAxisStart = Math.max(0, minSPR - 10); // Start 10 units before the lowest SPR, but not below 0
  // Generate posterior distribution data points
  const generatePosteriorData = (): DataPoint[] => {
    const sortedData = [...data].sort((a, b) => b.stoppingPower - a.stoppingPower);
    const distributionPoints: DataPoint[] = [];
    // Create more points along the x-axis (SPR values) with smaller intervals
    // Using an even smaller interval of 0.25 for smoother curves
    for (let i = xAxisStart; i <= 100; i += 0.25) {
      const point: DataPoint = {
        spr: i
      };
      // For each asset, calculate probability density at this SPR point
      sortedData.forEach(asset => {
        // Use a normal distribution with mean at the asset's SPR and standard deviation
        // Increasing the standard deviation to make curves wider
        const standardDeviation = asset.standardError * 18; // Increased from 15 to 18 for wider curves
        const mean = asset.stoppingPower;
        // Normal distribution formula
        const density = Math.exp(-0.5 * Math.pow((i - mean) / standardDeviation, 2)) / (standardDeviation * Math.sqrt(2 * Math.PI));
        // Scale the density for better visualization
        const scaleFactor = asset.id === 1 ? 1.0 : asset.id === 2 ? 0.6 : asset.id === 3 ? 0.4 : asset.id === 4 ? 0.3 : 0.2;
        point[asset.name] = density * scaleFactor;
      });
      distributionPoints.push(point);
    }
    return distributionPoints;
  };
  const posteriorData = generatePosteriorData();
  const sortedAssets = [...data].sort((a, b) => b.stoppingPower - a.stoppingPower);
  // Color mapping for different assets
  const getLineColor = (index: number) => {
    const colors = ['#D1005D', '#003B64', '#4BC0C0', '#9966FF', '#FFCE56'];
    return colors[index % colors.length];
  };
  // Generate tick values starting from xAxisStart with intervals of 5
  const generateTicks = () => {
    const ticks = [];
    const start = Math.ceil(xAxisStart / 5) * 5; // Round to nearest 5
    for (let i = start; i <= 100; i += 5) {
      ticks.push(i);
    }
    return ticks;
  };
  return;
};